import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { NewsService } from '../../../../shared-services/news.service';
import { INews, INewsCategory } from '../../../../interfaces/inews-list.interface';
import { SEOService } from '../../../../pages/shared/seoService';
import { IBreadcrumbsItem } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ALL_COMPLEXES, NEW_BUIDINGS, NEWS } from '../../../../shared-third-party/news-consts';
import { READY } from '../../../../shared-third-party/consts';
import { loadingStatus } from '../../../shared/components/loader/loader.component';
import { ActivatedRoute, Router } from '@angular/router';
import { updateRegistry } from '../../../../registry/operators/updateRegistry';
import { takeUntil } from 'rxjs/operators';
import { SearchForm } from '../../../../registry/helper/search-form';
import { REGISTRY_STORAGE } from '../../../../registry/registry-storage.token';
import { StorageInterface } from '../../../../registry/interfaces/storage.interface';
import { RegistryService } from '../../../../registry/service/registry.service';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrl: './news-list.component.scss',
})
export class NewsListComponent extends SearchForm implements OnInit, OnDestroy {
  loadingStatus: loadingStatus = READY;
  newsItems: INews[] = [];
  newsCategories: INewsCategory[] = [];
  complexTitles: string[] = [];
  selectedCategoryName = '';
  showCategoriesOptions = false;
  selectedComplexName = '';
  showComplexesOptions = false;
  breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'НДВ Супермаркет Недвижимости',
      href: '/',
    },
    {
      title: 'Новости',
      routerLink: '',
    },
  ];
  newsCount = 0;

  override form = new FormGroup({
    category: new FormControl(NEWS, Validators.required),
    complexTitle: new FormControl('Все комплексы'),
  });

  constructor(
    private newsService: NewsService,
    private seoService: SEOService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(REGISTRY_STORAGE) public override storage: StorageInterface,
    protected override registryService: RegistryService,
  ) {
    super(storage, registryService);
  }

  override ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['complexSlug']) {
        this.form.controls.category.patchValue(NEW_BUIDINGS);
        this.form.controls.complexTitle.patchValue(params['complexSlug']);
        this.search();
      }
    });

    updateRegistry(
      (this as NewsListComponent),
      this.newsService.getNews.bind(this.newsService),
    )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([result, count]) => {
        this.newsCount = count;
        this.newsItems = result?.entities?.newsItems || [];
        this.newsCategories = result?.entities?.categories || [];
        this.complexTitles = result?.entities?.complexTitles || [];
        this.cdr.detectChanges();
      });

    this.form.valueChanges.subscribe(() => {
      this.search();
    })
  }

  onCategorySelect(category: INewsCategory, event: Event): void {
    this.form.controls.category.setValue(category.categoryCode);
    this.selectedCategoryName = category.categoryName;
    this.showCategoriesOptions = false;
    event.stopPropagation();
  }

  onComplexSelect(complexTitle: string, event: Event): void {
    this.form.controls.complexTitle.setValue(complexTitle);
    this.selectedComplexName = complexTitle;
    this.showComplexesOptions = false;
    event.stopPropagation();
  }

  getH1String(): string {
    return this.seoService.getH1Title();
  }

  showComplexSelect(category: FormControl): boolean {
    return category.value === NEW_BUIDINGS;
  }

  clearComplexTitle(): void {
    if (this.form.get('category')?.value !== NEW_BUIDINGS) {
      this.form.get('complexTitle')?.setValue(ALL_COMPLEXES);
    }
  }
  toggleOptions(menu: string) {
    if (menu === 'categories') {
      this.showCategoriesOptions = !this.showCategoriesOptions;
      this.showComplexesOptions = false;
    } else if (menu === 'complexes') {
      this.showComplexesOptions = !this.showComplexesOptions;
      this.showCategoriesOptions = false;
    }
  }

  goToNews(newsItem: INews): void {
    const url = '/novosti/' + newsItem.slug + '-' + newsItem.id;
    this.router.navigate([url]);
  }

  prepareComplexLink(slug: string|null|undefined): string {
    return '/novostrojki/zhk/' + slug;
  }
}
